import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface LinkedInIconProps extends SvgIconProps {}

export const LinkedInIcon = ({
  style,
  ...iconProps
}: LinkedInIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon
      style={style}
      {...iconProps}
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <path
        d="M25.0003 0H1.99294C0.894375 0 0 0.871594 0 1.94484V25.0501C0 26.1259 0.894375 26.9992 1.99294 26.9992H25.002C26.1031 26.9992 27 26.1259 27 25.0501V1.94484C27 0.871594 26.1031 0 25.0003 0Z"
        fill="white"
      />
      <path
        d="M4.06703 10.2817H8.14262V23.3698H4.06703V10.2817ZM6.10183 3.76758C7.40207 3.76758 8.4589 4.8244 8.4589 6.12465C8.4589 7.42489 7.40207 8.48429 6.10269 8.48429C5.47721 8.48293 4.87772 8.23392 4.43536 7.79172C3.993 7.34952 3.74377 6.75013 3.74219 6.12465C3.74219 5.8149 3.80324 5.50818 3.92185 5.22204C4.04047 4.9359 4.21432 4.67595 4.43347 4.45704C4.65261 4.23813 4.91276 4.06456 5.19903 3.94626C5.4853 3.82796 5.79208 3.76724 6.10183 3.76758ZM10.6874 10.2817H14.589V12.0705H14.643C15.1864 11.0419 16.5132 9.95681 18.5 9.95681C22.6193 9.95681 23.3796 12.6679 23.3796 16.1915V23.3707H19.3143V17.004C19.3143 15.4869 19.2868 13.5327 17.2006 13.5327C15.0835 13.5327 14.7578 15.1869 14.7578 16.8926V23.3673H10.6934V10.2791L10.6874 10.2817Z"
        fill="#23305F"
      />
    </SvgIcon>
  );
};
